import axios from 'axios';

import { IModelEParameter } from '@/shared/model/model-e-parameter.model';

const baseApiUrl = 'api/model-e-parameters';

export default class ModelEParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelEParameter): Promise<IModelEParameter> {
    return new Promise<IModelEParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelEParameter> {
    return new Promise<IModelEParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
